export const getSentimentsSummaryUrl = () => 'agency/sentiments/summary';

export const getAuditNeededCallsUrl = () => 'agency/sentiments/audit_needed_calls';

export const getIssueContextsUrl = () => 'agency/sentiments/issue_contexts';

export const getToolErrorsUrl = () => 'agency/sentiments/tool_errors';

export const getResponseTimesUrl = () => 'agency/sentiments/response_times';

export const getSynchronizerLogsUrl = () => 'agency/synchronizer_logs';
